import React, {createContext, useState, useEffect, useCallback} from 'react';
import api from '../api';
import { useLocation } from "react-router-dom";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isAuthReady, setIsAuthReady] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isBanned, setIsBanned] = useState(false);
    const [currentUserId, setCurrentUserId] = useState(null);
    const [username, setUsername] = useState('');
    const [avatar, setAvatar] = useState(null);
    const [userRoles, setUserRoles] = useState([]);
    const [bannedEndDate, setBannedDate] = useState(null);
    const location = useLocation();

    useEffect(() => {
        const accessToken = localStorage.getItem('access_token');
        if (accessToken) {
            api.get('/api/auth/status')
                .then(response => {
                    if (response.data.isAuthenticated) setIsAuthenticated(true);
                    if (response.data.roles.includes('ROLE_ADMIN')) setIsAdmin(true);
                    if (response.data.roles) setUserRoles(response.data.roles);
                    if (response.data.is_banned) setIsBanned(true);
                    if (response.data.id) setCurrentUserId(response.data.id);
                    if (response.data.username) setUsername(response.data.username);
                    if (response.data.avatar) setAvatar(response.data.avatar);
                    if (response.data.ban_end_date) setBannedDate(response.data.ban_end_date);
                })
                .catch(() => {
                    setIsAuthenticated(false);
                    setIsAdmin(false);
                    setIsBanned(false);
                    setCurrentUserId(null);
                    setUsername(null);
                    setAvatar(null);
                })
                .finally(() => {
                    setIsAuthReady(true);
                });
        } else {
            setIsAuthReady(true);
        }
    }, [location.pathname]);

    const logOut = useCallback(()=> {
        setIsAuthenticated(false);
        setIsAdmin(false);
        setIsBanned(false);
        setCurrentUserId(null);
        setUsername(null);
        setAvatar(null);
    }, []);

    return (
        <AuthContext.Provider value={{ isAuthenticated, isAuthReady, isAdmin, isBanned, currentUserId, username, avatar, userRoles, bannedEndDate, logOut }}>
            {children}
        </AuthContext.Provider>
    );
};